<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-app>
        <template>
          <v-tabs
            color="deep-purple accent-4"
            v-model="activeTab"
            left
            @change="selectTabActive"
          >
            <v-tab>List History Enquery</v-tab>
            <v-tab>New App Enquery</v-tab>
            <v-tab-item>
              <v-card elevation="0">
                <v-row class="mt-5">
                  <v-col class="pl-10 d-flex" cols="12" sm="3">
                    <v-select
                      v-model="selectListAppEnq"
                      :items="itemsListAppEnq"
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-btn color="primary" dark @click="openDialogExportCSV">
                      Export to CSV
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
              <list-app-enq
                v-if="selectListAppEnq == 'Individu'"
                ref="listAppEnq"
              ></list-app-enq>
              <list-app-enq-b2b
                v-if="selectListAppEnq == 'Company'"
                ref="listAppEnqB2b"
              ></list-app-enq-b2b>
            </v-tab-item>
            <v-tab-item>
              <v-row class="ml-5 mt-5">
                <v-col class="d-flex" cols="12" sm="3">
                  <v-select
                    v-model="selectNewAppEnq"
                    :items="itemsNewAppEnq"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <new-app-enq
                v-if="selectNewAppEnq == 'Individu'"
                :setTabDefault="setTabDefault"
              ></new-app-enq>

              <new-app-enq-b2b
                v-if="selectNewAppEnq == 'Company'"
                :setTabDefault="setTabDefault"
              ></new-app-enq-b2b>
            </v-tab-item>
          </v-tabs>
        </template>
      </v-app>
    </div>

    <v-dialog v-model="dialogExportCSV" persistent max-width="340">
      <v-card>
        <v-card-title class="text-h5"> Range Date</v-card-title>
        <v-card-text>
          <v-date-picker
            v-model="datesExportCSV"
            range
            elevation="1"
          ></v-date-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogExportCSV = false">
            Close
          </v-btn>
          <v-btn :disabled="disableBtnExport" color="green darken-1" text>
            <download-excel
              v-if="selectListAppEnq == 'Individu'"
              :fetch="json_data"
              :fields="json_fields"
              :before-generate="startDownload"
              :before-finish="finishDownload"
              type="xls"
              :name="'enq_i' + datesExportCSV[0] + '.xls'"
            >
              Download
            </download-excel>
            <download-excel
              v-if="selectListAppEnq == 'Company'"
              :fetch="json_data"
              :fields="json_fields"
              :before-generate="startDownload"
              :before-finish="finishDownload"
              type="xls"
              :name="'enq_c' + datesExportCSV[0] + '.xls'"
            >
              Download
            </download-excel>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import vuetify from "@/plugins/vuetify";
import ListAppEnq from "./ListAppEnq.vue";
import ListAppEnqB2b from "./ListAppEnqB2b.vue";
import NewAppEnq from "./NewAppEnq.vue";
import NewAppEnqB2b from "./NewAppEnqB2b.vue";
import JsonExcel from "vue-json-excel";
export default {
  name: "LayoutClick",

  data: () => ({
    disableBtnExport: false,
    datesExportCSV: [new Date().toISOString().split("T")[0]],
    dialogExportCSV: false,
    activeTab: 0,
    selectNewAppEnq: "Individu",
    itemsNewAppEnq: ["Individu", "Company"],
    selectListAppEnq: "Individu",
    itemsListAppEnq: ["Individu", "Company"],
    json_fields: {
      No: "no",
      Nama: "nama",
      "Customer ID": "customer_id",
      "Provider Applican No": "provider_app_no",
      "Timestamp Consent": "time_stamp",
      "Reff Number": "reff_number",
      "Enquiry Bureau Date": "enq_date",
    },
  }),

  watch: {},

  components: {
    NewAppEnq,
    ListAppEnq,
    ListAppEnqB2b,
    NewAppEnqB2b,
    DownloadExcel: JsonExcel,
  },
  vuetify,
  methods: {
    selectTabActive() {
      if (this.activeTab == 0) {
        this.$refs?.listAppEnq?.getListNewAppEnq(1, 5);
        this.$refs?.listAppEnqB2b?.getListNewAppEnqB2b(1, 5);
      }
    },

    setTabDefault() {
      this.activeTab = 0;
      this.$refs?.listAppEnq?.getListNewAppEnq(1, 5);
      this.$refs?.listAppEnqB2b?.getListNewAppEnqB2b(1, 5);
    },

    openDialogExportCSV() {
      this.dialogExportCSV = true;

      if (this.selectListAppEnq == "Individu") {
        this.datesExportCSV = [
          new Date(this.$refs?.listAppEnq?.getLastDate())
            .toISOString()
            .split("T")[0],
        ];
      } else {
        this.datesExportCSV = [
          new Date(this.$refs?.listAppEnqB2b?.getLastDate())
            .toISOString()
            .split("T")[0],
        ];
      }
    },

    startDownload() {
      this.disableBtnExport = true;
    },

    finishDownload() {
      this.disableBtnExport = false;
      this.dialogExportCSV = false;
    },

    async json_data() {
      let params = "";

      if (this.datesExportCSV.length == 1) {
        params = { "filter[start_date]": this.datesExportCSV[0] };
      } else {
        params = {
          "filter[start_date]": this.datesExportCSV[0],
          "filter[end_date]": this.datesExportCSV[1],
        };
      }
      if (this.selectListAppEnq == "Individu") {
        await this.$store.dispatch("finance_click/getDataFilterDate", params);

        return await this.$store.getters["finance_click/list_data_export"];
      } else {
        await this.$store.dispatch(
          "finance_click_b2b/getDataFilterDate",
          params
        );

        return await this.$store.getters["finance_click_b2b/list_data_export"];
      }
    },
  },
};
</script>

<style>
.btn-download-csv {
  border-radius: 5px;
  display: inline-block;
  background: #a55eea;
  cursor: pointer;
  padding: 9px;
  color: white;
  font-weight: 500;
}
</style>